// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8c78a11d","469":"8c78a11d","811":"8c78a11d"}[chunkId] + ".chunk.js";
};